import $ from 'jquery';
import Snap from 'snapsvg';

class AnimatedHeader {
	constructor() {
		this.didScroll;
		this.lastScrollTop = 0;
		this.delta = 5;
		this.headerHeight = $('.header').outerHeight();
		this.scrollTop;

		this.events();
		this.searchBar();
	}

	events() {
		const that = this;

		$(window).scroll(function(e) {
			that.didScroll = true;
			that.scrollTop = $(this).scrollTop();
		});

		setInterval(function() {
			if (that.didScroll) {
				that.hasScrolled();
				that.didScroll = false;
			}
		}, 250);

		this.openMenu();
	}

	hasScrolled() {
		const that = this,
			  $header = $('.header');

		if(Math.abs(that.lastScrollTop - that.scrollTop) <= that.delta)
			return;

		// Scroll Down
		if(that.scrollTop > that.lastScrollTop && that.scrollTop > that.headerHeight) {
			$header.addClass('is-up');
		} else {
			// Scroll Up
			if(that.scrollTop + $(window).height() < $(document).height()) {
				$header.removeClass('is-up');
				$header.addClass('is-down');
			}

			if(that.scrollTop < 10) {
				$header.removeClass('is-down');
			}
		}

		this.lastScrollTop = that.scrollTop;
	}

	searchBar() {
		$('#navbarSearch').on('click', function(e) {
			e.preventDefault();

			$('#searchModal').slideToggle();
			$('#searchItem').focus();
		});
	}

	openMenu() {
		const that = this;

		$('#navbarMenuOpen').on('click', function(e) {
			e.preventDefault();

			const $this = $(this),
				  svg = document.getElementById("navbarTogglerSVG"),
				  menuSvg =  Snap(svg),
				  menuOpenTop = Snap.select('#menuOpenWhite1'),
				  menuOpenBottom = Snap.select('#menuOpenWhite2'),
				  menuCloseLeft = Snap.select('#menuCloseLeft'),
				  menuCloseRight = Snap.select('#menuCloseRight');

			const menuOpenTopPoints = menuOpenTop.node.getAttribute('d'),
				  menuOpenBottomPoints = menuOpenBottom.node.getAttribute('d'),
				  menuCloseLeftPoints = menuCloseLeft.node.getAttribute('d'),
				  menuCloseRightPoints = menuCloseRight.node.getAttribute('d');

			const oldWhite1 = "M70.7143593,53.5714316 C70.7143593,52.16518 69.5491793,51 68.1429276,51 L11.5714316,51 C10.16518,51 9,52.16518 9,53.5714316 L9,58.7142949 C9,60.1205466 10.16518,61.2857265 11.5714316,61.2857265 L68.1429276,61.2857265 C69.5491793,61.2857265 70.7143593,60.1205466 70.7143593,58.7142949 L70.7143593,53.5714316 Z",
				  oldWhite2 = "M70.7143593,25.5714316 C70.7143593,24.16518 69.5491793,23 68.1429276,23 L11.5714316,23 C10.16518,23 9,24.16518 9,25.5714316 L9,30.7142949 C9,32.1205466 10.16518,33.2857265 11.5714316,33.2857265 L68.1429276,33.2857265 C69.5491793,33.2857265 70.7143593,32.1205466 70.7143593,30.7142949 L70.7143593,25.5714316 Z";

			if ($this.hasClass('open')) {
				$('#navbarMenuContent').slideUp();
				$('#navbarBgBackdrop').fadeOut();
				$('#navbarBgBackdrop').removeClass('active');
				menuOpenTop.animate({ d: oldWhite1 }, 1000, mina.backout );
				menuOpenBottom.animate({ d: oldWhite2 }, 1000, mina.backout );
				$('.navbar-toggler').removeClass('open');
			} else {
				$('#navbarMenuContent').slideDown();
				$('#navbarBgBackdrop').fadeIn();
				$('#navbarBgBackdrop').addClass('active');
				menuOpenTop.animate({ d: menuCloseLeftPoints }, 1000, mina.backout );
				menuOpenBottom.animate({ d: menuCloseRightPoints }, 1000, mina.backout );
				$('.navbar-toggler').addClass('open');
			}
		});
	}
}

export default {
	init() {
		this.animatedHeader = new AnimatedHeader();
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/animatedHeader.js